import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../common/components/Dialog";
import { StyledButton } from "../../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { StyledTextField } from "../../../common/components/TextField/styles";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { InputAdornment } from "@mui/material";
import { IconButton } from "@mui/material";
import { serializeToString } from "xmlserializer";
import QRCode from "react-qr-code";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import Spinner from "../../../common/components/Spinner";
import * as yup from "yup";
import {
  createSubscriptionPlan,
  generateNewSubscriptionLink,
} from "../../../api/caseApi";

const CreateSubscriptionDialog = ({ open, onClose, caseDetails }) => {
  const { handleSubmit, control, reset, watch } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        thruEmail: yup.boolean().required(),
      })
    ),
  });

  const types = [
    { name: "Generate payment link", thruEmail: false },
    { name: "Send payment email", thruEmail: true },
  ];
  const [loading, setLoading] = useState(false);
  const [paymentLink, setPaymentLink] = useState("");
  const [modeOfPayment, setModeOfPayment] = useState(null);

  const thruEmail = watch("thruEmail");

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await generateNewSubscriptionLink(
        caseDetails.termsOfPayment2?.modeOfPayment?.name,
        caseDetails.id,
        values.thruEmail
      );

      setPaymentLink(response.data.link);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  const onImageCownload = () => {
    const svg = document.getElementById("QRCode");
    const svgData = serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.download = "AlinaPayQR";
      downloadLink.href = `${pngFile}`;
      downloadLink.click();
    };
    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
  };

  return (
    <div>
      <StyledDialog
        open={open}
        onClose={() => {
          onClose();
          reset();
        }}
        fullWidth
        maxWidth="md"
        width="900px"
      >
        <DialogTitle>Create Subscription Plan</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={6.5}>
                <Controller
                  control={control}
                  name="thruEmail"
                  render={({ field: { onChange }, fieldState: { error } }) => (
                    <Autocomplete
                      options={types}
                      onChange={(_, val) => {
                        onChange(val?.thruEmail);
                      }}
                      getOptionLabel={(option) => option.name || option}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(error)}
                          label={"Payment type"}
                          FormHelperTextProps={{ variant: "standard" }}
                          helperText={error && error.message}
                        />
                      )}
                      renderOption={(props, option) => {
                        return <li {...props}>{option.name}</li>;
                      }}
                      sx={{ width: "100%", paddingBottom: "20px" }}
                    />
                  )}
                />
              </Grid>
            </Grid>

            {thruEmail === false && (
              <Grid container direction={"column"} gap={1}>
                {caseDetails.termsOfPayment2?.modeOfPayment?.name.toLowerCase() ===
                  "paypal" && (
                  <Grid item xs={12}>
                    <StyledButton type="submit" theme="green">
                      Generate Paypal Payment Link
                    </StyledButton>
                  </Grid>
                )}
                {caseDetails.termsOfPayment2?.modeOfPayment?.name.toLowerCase() ===
                  "xendit" && (
                  <Grid item xs={12}>
                    <StyledButton type="submit" theme="green">
                      Generate Xendit Payment Link
                    </StyledButton>
                  </Grid>
                )}
              </Grid>
            )}

            {thruEmail === true && (
              <Grid container direction={"column"} gap={1}>
                {caseDetails.termsOfPayment2?.modeOfPayment?.name.toLowerCase() ===
                  "paypal" && (
                  <Grid item xs={12}>
                    <StyledButton type="submit" theme="green">
                      Send Payment Email via Paypal
                    </StyledButton>
                  </Grid>
                )}
                {caseDetails.termsOfPayment2?.modeOfPayment?.name.toLowerCase() ===
                  "xendit" && (
                  <Grid item xs={12}>
                    <StyledButton type="submit" theme="green">
                      Send Payment Email via Xendit
                    </StyledButton>
                  </Grid>
                )}
              </Grid>
            )}

            <Grid container rowSpacing={2}>
              <Grid
                item
                xs={12}
                style={{ display: !loading ? "none" : "inherit" }}
              >
                <Spinner color={"black"} />
              </Grid>
              {paymentLink !== "" && (
                <Grid
                  rowSpacing={2}
                  container
                  style={{
                    border: "1px solid #d6d6d6",
                    padding: "10px",
                    borderRadius: "5px",
                    marginBottom: "20px",
                    marginTop: "50px",
                  }}
                >
                  <Grid item xs={5}>
                    <QRCode
                      id="QRCode"
                      size={256}
                      style={{
                        height: "auto",
                        maxWidth: "60%",
                        width: "60%",
                      }}
                      value={paymentLink}
                      viewBox={`0 0 256 256`}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <StyledButton onClick={onImageCownload} theme="green">
                      Download QR Code
                    </StyledButton>
                  </Grid>

                  <Grid item xs={12}>
                    Or
                  </Grid>
                  <Grid item xs={12}>
                    <StyledTextField
                      inputProps={{ readOnly: true }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                navigator.clipboard.writeText(paymentLink)
                              }
                              sx={{ width: "36px", height: "32px" }}
                            >
                              <FontAwesomeIcon
                                fontSize="medium"
                                icon={faCopy}
                              />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      value={paymentLink}
                      label={"Link"}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </DialogContent>

          <DialogActions>
            <Grid item xs={12}>
              <StyledButton
                theme="purple"
                type="button"
                onClick={() => {
                  reset();
                  onClose();
                }}
              >
                Cancel
              </StyledButton>
            </Grid>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default CreateSubscriptionDialog;
